const BLACKLISTED_FONT_STYLE_PROPS = ["font-size", "color", "font-family", "background-color"]

export function stripBlacklistedFontStyles(html) {
    if (html == null || html === "" || html === "undefined") return ""
    const div = document.createElement("div")
    div.innerHTML = html
    div.querySelectorAll("[style]").forEach((el) => {
        for (const prop of BLACKLISTED_FONT_STYLE_PROPS) {
            el.style.removeProperty(prop)
        }
        if (!el.getAttribute("style")?.trim()) {
            el.removeAttribute("style")
        }
    })
    return div.innerHTML
}
